/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum ButtonDirectionEnum {
    RIGHT = 'right',
    LEFT = 'left',
}
